import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { FONT_FAMILY } from "../../theme";
import { styles } from "./styles";

export const CustomLinearProgress = (
  props: LinearProgressProps & { value?: number }
): JSX.Element => {
  return (
    <Box sx={styles.customLinearProgress}>
      <Box sx={styles.linearProgressContainer}>
        <LinearProgress
          variant={props.value ? "determinate" : "indeterminate"}
          {...props}
          color="inherit"
          sx={{ height: 8, borderRadius: 4 }}
        />
      </Box>
      {props.value && (
        <Box sx={{ minWidth: 35 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontFamily: FONT_FAMILY }}
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      )}
    </Box>
  );
};
